module.exports = __webpack_public_path__ + "slider-05.jpg?f434035d8d17b2ad3f5f788ff20e33d0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slider-05.jpg
// module id = 270
// module chunks = 0